<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 110vh"
  >
    <v-row>
      <v-col cols="12" v-if="loading"><LoadCard /></v-col>
      <v-col cols="12" v-else-if="vehicleList.length > 0">
        <v-card class="pa-3 elevation-0"  >
          <Table :data="vehicleList" />
        </v-card>
      </v-col>
      <v-col v-else>
        <v-card class="text-center py-16 elevation-0">
          <h3 class="gray-text ma-3">{{ $t("vehicle.empty") }}</h3>
          <P class="gray-text">{{ $t("vehicle.lable") }}.</P>
          <v-chip
            close-icon="mdi-delete"
            color="primary"
            @click="openDialog()"
            label
            outlined
            >{{ $t("vehicle.create") }}
          </v-chip>
        </v-card>
      </v-col>
    </v-row>
    <v-btn
      fixed
      color="primary"
      class="white--text ma-3"
      @click="openDialog()"
      fab
      left
      bottom
      v-if="$i18n.locale == 'ar'"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-btn
      fixed
      color="primary"
      class="white--text ma-3"
      @click="openDialog()"
      fab
      right
      bottom
      v-else
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <Popup :dialog="dialog" :update="false" :data="{}" @close-dialog="close" />
  </v-container>
</template>

<script>
import LoadCard from "@/views/components/LoadCard.vue";
import Table from "./Table.vue";
import Popup from "./Popup.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "vehicle-page",
  components: {
    Table,
    Popup,
    LoadCard,
  },
  data() {
    return {
      clicked: false,
      param: null,
      dialog: false,
    };
  },
  computed: {
    ...mapState("vehicleStore", ["vehicleList", "loading"]),

    viewVehicle() {
      return this.vehicleList.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
  },
  methods: {
    ...mapActions("vehicleStore", ["list"]),
    openDialog() {
      this.dialog = true;
    },
    close(val) {
      this.dialog = val;
      const filter = {};
      this.list(filter);
    },
    refresh() {
      const filter = {};
      this.list(filter);
    },
  },
  created() {
    this.param = this.$router.history.current.params;
  },
  mounted() {
    const filter = {};
    this.list(filter);
    // cl.list(filter).then((res) => {
    //   this.cars = res.data.data.rows;
    //   this.pagination = res.data.data.pagination;
    //   this.loading = false;
    // });
  },
};
</script>
